import { NEUTRAL_RGB_HEX } from 'enums/session-recap/colors';

export interface IDotColor {
  color: string;
  /** e.g. colouring by exit velo for a pitch without contact */
  muted: boolean;
}

export const MUTED: IDotColor = {
  color: NEUTRAL_RGB_HEX,
  muted: true,
};
